import { useState, useEffect } from "react";

import './WhatAreTheBenefits.css';

import { GetDataPage, RegisterDataPage } from "interface/Data";

export default function MesaUnimil_WhatAreTheBenefits(props){
    
    const [ dataPage, setDataPage ]         = useState(GetDataPage('unimil'));

    const [ title, setTitle ]       = useState('');
    const [ subtitle, setSubtitle ] = useState('');
    const [ text, setText ]         = useState('');
    const [ img, setImg ]           = useState('');

    useEffect(()=>{
        RegisterDataPage('unimil', setDataPage);
    }, []);

    useEffect(()=>{
        setDataPage(GetDataPage('unimil'));

        InitialData('subtitle');
        InitialData('button');
        InitialData('text');
        InitialData('img');
    }, [dataPage]);

    function InitialData(type){
        setTimeout(() => {
            switch (type) {
                case 'subtitle':
                        setTitle(GetDataPage('unimil').about['subtitle_2']);
                    break;

                case 'button':
                        setSubtitle(GetDataPage('unimil').about['button_2']);
                    break;
                    
                case 'text':
                        setText(GetDataPage('unimil').about['text_2']);
                    break;
                    
                case 'img':
                        setImg(GetDataPage('unimil').about['img_2']);
                    break;
            }
        }, 1000); 
    }
    
    return(
        <div className="MesaUnimil_WhatAreTheBenefits">
            <div className="div_data">
                <div className="div_topic_all">
                    <div className="div_home_page">
                        <div className="div_home" onClick={ ()=>{ props.ClickPage('index'); } }>
                            <img alt="img" src="./assets/home.png" className="img_home" />
                        </div>
                        <div className="div_name_page">
                            <div className="subtitle_page">{ title }</div>
                            <div className="name_page">{ subtitle }</div>
                        </div>  
                    </div>              
                    <div className="div_logotipo">
                        <img alt="img" src="./assets/Unimil/logo.png" className="logotipo" />
                    </div>   
                </div>
                <div className="contents">
                    <div className="text" dangerouslySetInnerHTML={ { __html: text ? text.replaceAll('&#34;', '"').replaceAll('<li><br></li>', '') : "" } } />
                    <div className="img">
                        <img alt="img" src={ img } className="show_img_example" />
                    </div>
                </div>
            </div>
        </div>
    )
}